import Modal from 'react-modal'
import { useLang } from '../utils/hooks'
import { langRemove } from '../assets/langRemove'

const RemoveBoardSailModal = ({ options, handleClose, handleDoDelete }) => {
  const { lang } = useLang()
  const choosenLang = lang === 'fr' ? langRemove.fr : langRemove.eng
  return (
    <Modal
      isOpen={options.removeModalIsOpen}
      onRequestClose={handleClose}
      appElement={document.getElementById('root')}
      closeTimeoutMS={300}
      className="modify-modal"
      overlayClassName="modify-modal-overlay"
    >
      <div className="block">
        <label className="label">
          {choosenLang.deleteConfirm + options.removeTitle} ?
        </label>
      </div>

      <div className="block">
        <div className="field is-grouped">
          <div className="control">
            <button
              className="button is-alert"
              data-dismiss="modal"
              onClick={handleClose}
            >
              {choosenLang.cancel}
            </button>
          </div>

          <div className="control">
            <button
              className={'button is-danger '}
              data-dismiss="modal"
              onClick={handleDoDelete}
            >
              {choosenLang.confirm}
            </button>
          </div>
        </div>
      </div>
    </Modal>
  )
}

export default RemoveBoardSailModal
